@use '../../../styles/Colors.scss' as Colors;
@use '../../../styles/Constants.scss' as Constants;

$var-inputWidth: 60px;
$var-inputHeight: 32px;


.pagination-footer {
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
	background-color: Colors.$col-greyLight;
	padding: Constants.$val-spacing-s Constants.$val-spacing-m;

	&__dropdown {
		background-color: Colors.$col-white;
		margin: 0 Constants.$val-spacing-s;
		border-radius: Constants.$val-borderRadius;
	}

	& > input {
		max-width: $var-inputWidth;
		max-height: $var-inputHeight;
		border: 1px solid Colors.$col-greyMid;
		margin: 0 Constants.$val-spacing-s;
		border-radius: Constants.$val-borderRadius;
	}

	& > button {
		border: 1px solid Colors.$col-greyMid;
		background-color: Colors.$col-white;
		height: $var-inputHeight;
		width: $var-inputHeight;
		margin: 0 Constants.$val-spacing-s;
		border-radius: Constants.$val-borderRadius;
		color: Colors.$col-greyFontLight;
		display: flex;
		align-items: center;
		font-size: Constants.$val-fontSizeBig;
	}
}

.disabled {
	pointer-events: none;
}